import { types } from 'mobx-state-tree';

export const ServerStat = types.model('ServerStat', {
  name: types.string,
  value: types.optional(types.number, 0),
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/stores/ServerStatsStore/ServerStat.ts